import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a1f44b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "car-box" }
const _hoisted_2 = { class: "card-box" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "flex-box align-center justify-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-label" }, "来访车辆", -1))
const _hoisted_6 = { class: "title-value" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = {
  key: 0,
  class: "car-list"
}
const _hoisted_9 = { class: "car-item-rank" }
const _hoisted_10 = { class: "car-item-num" }
const _hoisted_11 = { class: "car-item-name" }
const _hoisted_12 = { class: "car-item-tel" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "empty-box"
}
const _hoisted_15 = { class: "add-line" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-add" }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add-text" }, "添加车辆", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-tip" }, " 注：申请通过将短信通知该人员，扫描寺方人员提供的 接待二维码，凭访客二维码通行。 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_area = _resolveComponent("form-area")!
  const _component_c_modal = _resolveComponent("c-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.list.length), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.list && _ctx.list.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (c, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: c.key,
                    class: "car-item flex-box align-center"
                  }, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(i + 1), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(c.num), 1),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(c.name), 1),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(c.tel), 1),
                    _createElementVNode("div", {
                      class: "car-item-remove icon-delete",
                      onClick: ($event: any) => (_ctx.removeCar(i))
                    }, null, 8, _hoisted_13)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, "暂无信息"))
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", {
          class: "flex-box align-center",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showAdd && _ctx.showAdd(...args)))
        }, _hoisted_18)
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_c_modal, {
        ref: "modal",
        title: "添加车辆信息",
        "on-confirm": _ctx.confirmAdd
      }, {
        default: _withCtx(() => [
          _createVNode(_component_form_area, {
            ref: "formRef",
            config: _ctx.form,
            value: _ctx.initial,
            "button-text": ""
          }, null, 8, ["config", "value"]),
          _hoisted_19
        ]),
        _: 1
      }, 8, ["on-confirm"])
    ]))
  ], 64))
}